import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'fn-theme';
export const THEMES = ['system', 'light', 'dark'];

/*
 * Theme preference, persisted across visits.
 *
 * tokens.css already handles the presentation: it reads
 * prefers-color-scheme by default and lets :root[data-theme] override it.
 * This only decides which of the three states is active and stamps the
 * attribute, so "system" means removing it rather than resolving it here —
 * the OS setting then continues to apply live.
 */
export function useTheme() {
	const [theme, setThemeState] = useState(() => {
		if (typeof window === 'undefined') return 'system';
		const stored = window.localStorage?.getItem(STORAGE_KEY);
		return THEMES.includes(stored) ? stored : 'system';
	});

	useEffect(() => {
		const root = document.documentElement;
		if (theme === 'system') root.removeAttribute('data-theme');
		else root.setAttribute('data-theme', theme);

		try {
			if (theme === 'system') window.localStorage.removeItem(STORAGE_KEY);
			else window.localStorage.setItem(STORAGE_KEY, theme);
		} catch {
			/* Private browsing can refuse storage; the theme still applies. */
		}
	}, [theme]);

	const setTheme = useCallback((next) => {
		if (THEMES.includes(next)) setThemeState(next);
	}, []);

	return { theme, setTheme };
}
